(function () {
  var root = document.querySelector('[data-product-root]');
  if (!root) return;
  var sectionId = root.dataset.sectionId;

  var variantsScript = document.querySelector('[data-product-json-' + sectionId + ']');
  var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

  var form = root.querySelector('.jelly-product-form');
  var variantIdInput = root.querySelector('[data-variant-id-input]');
  var addBtn = root.querySelector('[data-add-cart-btn]');
  var cartMessage = root.querySelector('[data-cart-message]');
  var mainImage = document.getElementById('MainImage-' + sectionId);
  var thumbs = document.querySelectorAll('#Thumbs-' + sectionId + ' .thumb');
  var priceEl = root.querySelector('[data-cart-btn-price]');

  var selectedOptions = {};
  root.querySelectorAll('[data-option-position].swatch-btn.active, [data-option-position].size-btn.active').forEach(function (el) {
    selectedOptions[el.dataset.optionPosition] = el.dataset.optionValue;
  });

  function findVariant() {
    return variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return Object.keys(selectedOptions).every(function (pos) {
        return opts[parseInt(pos, 10) - 1] === selectedOptions[pos];
      });
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateOptionUI() {
    root.querySelectorAll('[data-option-position]').forEach(function (btn) {
      if (!btn.classList.contains('swatch-btn') && !btn.classList.contains('size-btn')) return;
      var pos = btn.dataset.optionPosition;
      btn.classList.toggle('active', btn.dataset.optionValue === selectedOptions[pos]);
    });
    root.querySelectorAll('.option-block').forEach(function (block) {
      var pos = block.dataset.optionPosition;
      var nameEl = block.querySelector('[data-option-selected-name]');
      if (nameEl && pos) nameEl.textContent = selectedOptions[pos] || '';
    });
  }

  function selectVariant(variant) {
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;

    if (variant.featured_image && mainImage) {
      mainImage.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_900x$1$2');
      mainImage.alt = variant.featured_image.alt || '';
    }

    thumbs.forEach(function (t) {
      t.classList.toggle('active', variant.featured_media && String(variant.featured_media.id) === t.dataset.mediaId);
    });

    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (!variant.available) {
        addBtn.textContent = 'Épuisé';
      } else {
        renderBundles();
      }
    }
  }

  root.querySelectorAll('.swatch-btn, .size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectedOptions[btn.dataset.optionPosition] = btn.dataset.optionValue;
      updateOptionUI();
      updateDimensions();
      var variant = findVariant();
      selectVariant(variant);
    });
  });

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImage) mainImage.src = t.dataset.mediaSrc;
      thumbs.forEach(function (o) { o.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  var bundles = [
    { qty: 1, label: '1 sac', tag: null, discount: 0 },
    { qty: 2, label: '2 sacs', tag: 'Le plus choisi', discount: 0.15 },
    { qty: 3, label: '3 sacs', tag: 'Meilleure offre', discount: 0.30 },
  ];
  var currentBundle = 1;
  var bundleRow = document.getElementById('BundleRow-' + sectionId);

  function priceFor(basePriceCents, bundle) {
    var total = basePriceCents * bundle.qty;
    var now = Math.round(total * (1 - bundle.discount));
    return { now: now, old: total };
  }

  function renderBundles() {
    var variant = findVariant() || variants[0];
    if (!bundleRow) {
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      return;
    }
    var basePrice = variant.price;

    bundleRow.innerHTML = bundles
      .map(function (b, i) {
        var p = priceFor(basePrice, b);
        var sub = b.discount > 0 ? 'Soit ' + formatMoney(Math.round(p.now / b.qty)) + ' / sac' : 'Prix unitaire';
        return (
          '<div class="bundle-option' + (i === currentBundle ? ' active' : '') + '" data-idx="' + i + '">' +
          (b.tag ? '<span class="bundle-tag">' + b.tag + '</span>' : '') +
          '<div class="bundle-left"><div class="bundle-radio"><span></span></div><div>' +
          '<div class="bundle-title">' + b.label + '</div>' +
          '<div class="bundle-sub">' + sub + '</div></div></div>' +
          '<div class="bundle-price"><div class="bundle-price-now">' + formatMoney(p.now) + '</div>' +
          (b.discount > 0 ? '<div class="bundle-price-old">' + formatMoney(p.old) + '</div>' : '') +
          '</div></div>'
        );
      })
      .join('');

    bundleRow.querySelectorAll('.bundle-option').forEach(function (el) {
      el.addEventListener('click', function () {
        currentBundle = parseInt(el.dataset.idx, 10);
        renderBundles();
      });
    });

    if (priceEl) priceEl.textContent = formatMoney(priceFor(basePrice, bundles[currentBundle]).now);
  }

  var dimData = [];
  var dimScript = document.querySelector('[data-dimension-data-' + sectionId + ']');
  if (dimScript) {
    try { dimData = JSON.parse(dimScript.textContent); } catch (e) { dimData = []; }
  }
  function updateDimensions() {
    if (!dimData.length) return;
    var sizeValue = Object.values(selectedOptions).find(function (v) {
      return dimData.some(function (d) { return d.size_value === v; });
    });
    var match = dimData.find(function (d) { return d.size_value === sizeValue; }) || dimData.find(function (d) { return !d.size_value; }) || dimData[0];
    if (!match) return;
    var grid = document.getElementById('DimsGrid-' + sectionId);
    if (!grid) return;
    var w = grid.querySelector('[data-dim="width"]');
    var h = grid.querySelector('[data-dim="height"]');
    var d = grid.querySelector('[data-dim="depth"]');
    if (w) w.textContent = match.width;
    if (h) h.textContent = match.height;
    if (d) d.textContent = match.depth;
  }

  function addToCart(items, messageEl, button) {
    var originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Ajout...';
    }
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          if (messageEl) {
            messageEl.hidden = false;
            messageEl.classList.add('error');
            messageEl.textContent = data.description || data.message || 'Une erreur est survenue.';
          }
          if (button) button.textContent = originalText;
          return;
        }
        if (messageEl) {
          messageEl.hidden = false;
          messageEl.classList.remove('error');
          messageEl.textContent = 'Ajouté au panier !';
        }
        if (button) button.textContent = originalText;
        fetch(window.routes.cart_url + '.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));
          });
      })
      .catch(function () {
        if (messageEl) {
          messageEl.hidden = false;
          messageEl.classList.add('error');
          messageEl.textContent = 'Une erreur est survenue, réessaie.';
        }
        if (button) button.textContent = originalText;
      })
      .finally(function () {
        if (button) button.disabled = false;
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variant = findVariant() || variants[0];
      var qty = bundleRow ? bundles[currentBundle].qty : 1;
      addToCart([{ id: variant.id, quantity: qty }], cartMessage, addBtn);
    });
  }

  root.querySelectorAll('[data-addon-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      addToCart([{ id: variantId, quantity: 1 }], null, null);
      btn.classList.add('added');
      btn.textContent = 'Ajouté ✓';
      setTimeout(function () {
        btn.classList.remove('added');
        btn.textContent = 'Ajouter';
      }, 2000);
    });
  });

  root.querySelectorAll('[data-acc-head]').forEach(function (head) {
    head.addEventListener('click', function () {
      head.closest('.acc-item').classList.toggle('open');
    });
  });

  updateDimensions();
  renderBundles();
})();
